<script setup lang="ts">
import { computed } from "vue";
import { useDisplay } from 'vuetify'
import { useI18n } from 'vue-i18n';
import { PrimaryButton } from '@es-bill/es-bill-common-components';
import type { FormEnergyCommunity } from '@/stores/communityApiStore';

const { t } = useI18n();
const { width } = useDisplay()


const props = defineProps<{
  communityPublic?: FormEnergyCommunity;
}>()

const orderText = computed(() => width.value<796?2:1);
const orderImage = computed(() => width.value<796?1:2);

const colsTextOrImage = computed(() => width.value < 796 ? 12 : 6);

</script>

<template>
  <v-container class="containerStandard">

    <v-row>
      <v-col class="" :order="orderText" :cols="colsTextOrImage">
        <p class="textHeadline textCol">{{ communityPublic?.name }}</p>

        <p class="textDescriptorCompact">{{ communityPublic?.addressPostal.address }}</p>
        <p class="textDescriptorCompact">{{ communityPublic?.addressPostal.addressExtra }}</p>
        <p class="textDescriptorCompact">{{ communityPublic?.addressPostal.zip }}
          {{ communityPublic?.addressPostal.city }}</p>
        <br/>

        <p v-if="communityPublic?.communityType === '16a'" class="textDescriptorTitle">{{ t('operator') }}</p>
        <p v-if="communityPublic?.communityType === '16a'" class="textDescriptorCompact">{{ communityPublic?.addressPostal.name }}</p>
        <p v-if="communityPublic?.communityType === '16a'" class="textDescriptorTitle">&nbsp;</p>

        <div>
          <p v-if="(communityPublic?.contacts ?? []).length > 0" class="textDescriptorTitle">{{ t('contactPerson') }}</p>
          <p v-for="(contact, index) in (communityPublic?.contacts ?? [])" :key="index" class="textDescriptor">

            <span>{{ contact.name }}</span>

            <br v-if="contact.phone"/>
            <span>{{ contact.phone }}</span>

            <br v-if="contact.emailAddress"/>
            <span>{{ contact.emailAddress }}</span>
          </p>
        </div>
        <br/>




        <p class="textDescriptorTitle">{{ t('ecNumber') }}</p>
        <p class="textDescriptorCompact">{{ communityPublic?.ecn }}</p>
        <br/>

        <p v-if="communityPublic?.legal.length" class="textDescriptorTitle">{{ communityPublic?.legal }}</p>
        <div v-if="communityPublic?.identificationType.length">
          <p class="textDescriptorCompact">{{ communityPublic?.identificationType }}:
            {{ communityPublic?.identification }}</p>
          <br/>
        </div>

        <p v-if="communityPublic?.dso && communityPublic?.communityType !== '16b'" class="textDescriptorTitle">{{ t('grid_operator') }}</p>
        <p v-if="communityPublic?.dso && communityPublic?.communityType !== '16b'"  class="textDescriptorCompact">{{ communityPublic?.dso }}</p>
        <br v-if="communityPublic?.dso && communityPublic?.communityType !== '16b'"/>

        <p v-if="communityPublic?.transformerReference?.length"  class="textDescriptorTitle">{{ t('transformerReference') }}</p>
        <p v-if="communityPublic?.transformerReference?.length"  class="textDescriptorCompact">{{ communityPublic?.transformerReference }}</p>
        <br v-if="communityPublic?.transformerReference?.length" />

        <p v-if="communityPublic?.substationReference?.length"  class="textDescriptorTitle">{{ t('substationReference') }}</p>
        <p v-if="communityPublic?.substationReference?.length"  class="textDescriptorCompact">{{ communityPublic?.substationReference }}</p>
        <br v-if="communityPublic?.substationReference?.length" />

        <div v-if="communityPublic?.communityType !== '16a'">
          <p v-if="communityPublic?.dsoLinkCheck?.length" class="textDescriptorTitle">{{ t('areaInformation') }}</p>
          <p v-if="communityPublic?.dsoLinkCheck?.length" class="textDescriptorCompact"><a :href="communityPublic?.dsoLinkCheck" target="_blank">{{ communityPublic?.dsoLinkCheck }}</a></p>
          <br v-if="communityPublic?.dsoLinkCheck?.length" />
        </div>

        <p v-if="communityPublic?.linkCustomerPortal?.length" class="textDescriptorTitle">{{ t('portal')+" "+t('grid_operator') }}</p>
        <p v-if="communityPublic?.linkCustomerPortal?.length" class="textDescriptorCompact"><a :href="communityPublic?.linkCustomerPortal" target="_blank">{{ communityPublic?.linkCustomerPortal }}</a></p>
        <br v-if="communityPublic?.linkCustomerPortal?.length" />

        <p v-if="communityPublic?.communityNotes?.length" class="textDescriptorTitle">{{ t('communityHints') }}</p>
        <p v-if="communityPublic?.communityNotes?.length" class="textDescriptorCompact">{{communityPublic?.communityNotes}}</p>
        <br v-if="communityPublic?.communityNotes?.length" />

        <p v-if="communityPublic?.uriMoreInfo?.length" class="textDescriptorTitle">{{ t('moreInfoCommunity') }}</p>
        <p v-if="communityPublic?.uriMoreInfo?.length" class="textDescriptorCompact"><a :href="communityPublic?.uriMoreInfo" target="_blank">{{ t('clickHere') }}</a></p>
        <br v-if="communityPublic?.uriMoreInfo?.length" />


      </v-col>

      <v-col class="" :order="orderImage" :cols="colsTextOrImage">
        <v-img
          width="200"
          :src="communityPublic?.logoSrc"
          alt="logo-eeg"
          :class="{'ml-auto': orderImage===2}"
        ></v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="colRight text-amber-accent-1">
        <router-link :to="{name: 'JoinAsMember', params: {ecn: communityPublic?.ecn}}">
        <PrimaryButton append-icon="mdi-arrow-right" :text="t('memberJoinStepper.apply')"/>
        </router-link>
      </v-col>
    </v-row>

  </v-container>
</template>




